export enum EntityScopeEnum {
  Global = 1,
  Project = 2,
  User = 4
}
